/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './defs.defs'

const $nsid = 'com.atproto.label.subscribeLabels'

type $nsid = typeof $nsid

export { $nsid }

type Info = {
  $type?: 'com.atproto.label.subscribeLabels#info'
  name: 'OutdatedCursor' | l.UnknownString
  message?: string
}

export type { Info }

const info = /*#__PURE__*/ l.typedObject<Info>(
  $nsid,
  'info',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string<{ knownValues: ['OutdatedCursor'] }>(),
    message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { info }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
})

export type $Params = l.InferOutput<typeof $params>

export const $message = /*#__PURE__*/ l.typedUnion(
  [
    /*#__PURE__*/ l.typedRef<Labels>((() => labels) as any),
    /*#__PURE__*/ l.typedRef<Info>((() => info) as any),
  ],
  false,
)

export type $Message = l.InferOutput<typeof $message>

/** Subscribe to stream of labels (and negations). Public endpoint implemented by mod services. Uses same sequencing scheme as repo event stream. */
const main = /*#__PURE__*/ l.subscription($nsid, $params, $message, [
  'FutureCursor',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Labels = {
  $type?: 'com.atproto.label.subscribeLabels#labels'
  seq: number
  labels: LabelDefs.Label[]
}

export type { Labels }

const labels = /*#__PURE__*/ l.typedObject<Labels>(
  $nsid,
  'labels',
  /*#__PURE__*/ l.object({
    seq: /*#__PURE__*/ l.integer(),
    labels: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
    ),
  }),
)

export { labels }
